import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge, Spinner, ProgressBar, Tabs, Tab, Modal, Alert, Form } from 'react-bootstrap';

import { FaWallet, FaUsers, FaLink, FaChartLine, FaGem, FaCheckCircle, FaMoneyBillWave, FaTools, FaUserCheck, FaSitemap, FaUserPlus, FaExchangeAlt, FaUserTie, FaCopy, FaSync } from 'react-icons/fa';
import api from '../services/api';

const AgencyDashboard = () => {
    const [agencyData, setAgencyData] = useState(null);
    const [summary, setSummary] = useState({ balance: 0, totalEarned: 0, totalWithdrawn: 0, totalCustomers: 0, activeCustomers: 0 });
    
    const [directCustomers, setDirectCustomers] = useState([]); 
    const [subAgencies, setSubAgencies] = useState([]);         
    const [subCustomers, setSubCustomers] = useState([]);       

    const [withdrawals, setWithdrawals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [copied, setCopied] = useState(false);
    
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [withdrawLoading, setWithdrawLoading] = useState(false);
    const [withdrawError, setWithdrawError] = useState(null);

    const [bankForm, setBankForm] = useState({ bankName: '', bankNumber: '', bankHolder: '' });
    const [saveLoading, setSaveLoading] = useState(false);

    const [showConvertModal, setShowConvertModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [convertLoading, setConvertLoading] = useState(false);

    useEffect(() => {
        fetchAllData();
    }, []);

    useEffect(() => {
        if (agencyData?.bankInfo) {
            setBankForm({
                bankName: agencyData.bankInfo.bankName || '',
                bankNumber: agencyData.bankInfo.bankNumber || '',
                bankHolder: agencyData.bankInfo.bankHolder || ''
            });
        }
    }, [agencyData]);

const fetchAllData = async () => {
    setLoading(true);
    try {
        // LƯU Ý QUAN TRỌNG: Backend của bố định nghĩa route là '/my-stats'
        // Bố hãy chắc chắn rằng đường dẫn gọi API phải khớp chính xác
        const [statsRes, withdrawRes] = await Promise.all([
            api.get('/api/agency/my-stats'), // Sửa từ my-stats-v2 thành my-stats
            api.get('/api/agency/my-withdrawals')
        ]);

        console.log("📡 Dữ liệu Server trả về (Check xem có agencySlug không):", statsRes.data);

        if (statsRes.data?.success) {
            // Gán dữ liệu vào state
            setAgencyData(statsRes.data.agency || null);
            setSummary(statsRes.data.summary || { balance: 0, totalEarned: 0, totalWithdrawn: 0, totalCustomers: 0, activeCustomers: 0 });
            setDirectCustomers(statsRes.data.customers || []); // Đảm bảo trùng tên trường với Backend
            setSubAgencies(statsRes.data.subAgencies || []);
            setSubCustomers(statsRes.data.subCustomers || []);
            
            // Debug nhanh: Kiểm tra xem mã đại lý có tồn tại không
            if (statsRes.data.agency?.agencySlug) {
                console.log("✅ Mã đại lý đã tải về:", statsRes.data.agency.agencySlug);
            } else {
                console.warn("⚠️ Cảnh báo: Server trả về thành công nhưng agencySlug bị rỗng!");
            }
        }
        
        if (withdrawRes.data?.success) {
            setWithdrawals(withdrawRes.data.withdrawals || []);
        }
    } catch (err) {
        console.error("❌ Lỗi đồng bộ dữ liệu đại lý:", err.response?.data || err);
        alert("Lỗi tải dữ liệu đại lý, vui lòng kiểm tra kết nối.");
    } finally {
        setLoading(false);
    }
};
// Lấy mã từ agencyData (dữ liệu thật từ server), dự phòng trường hợp đang tải
    const currentSlug = agencyData?.agencySlug;
    const landingLink = currentSlug 
        ? `${window.location.origin}/register?ref=${currentSlug}` 
        : "Đang tải mã...";

    const copyLink = () => {
        const slug = agencyData?.agencySlug;
        
        if (!slug || slug === 'undefined' || slug === 'null' || slug === "") {
            alert("❌ Mã đại lý chưa được cấu hình. Vui lòng liên hệ Admin!");
            return;
        }
        
        const link = `${window.location.origin}/register?ref=${slug}`;
        
        navigator.clipboard.writeText(link).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(err => {
            console.error("Lỗi copy:", err);
            alert("Trình duyệt chặn tính năng copy, bố hãy copy tay: " + link);
        });
    };
    const handleUpdateBank = async () => {
        setSaveLoading(true);
        try {
            const res = await api.post('/agency/update-bank', bankForm);
            if (res.data.success) {
                alert("✅ Cập nhật thông tin ngân hàng thành công!");
                fetchAllData();
            }
        } catch (err) {
            alert(err.response?.data?.message || "Lỗi cập nhật ngân hàng");
        } finally {
            setSaveLoading(false);
        }
    };

    const handleRequestWithdraw = async () => {
        setWithdrawLoading(true);
        setWithdrawError(null);
        try {
            const res = await api.post('/api/agency/request-withdraw');
            if (res.data.success) {
                alert(res.data.message);
                setShowWithdrawModal(false);
                fetchAllData(); 
            }
        } catch (err) {
            setWithdrawError(err.response?.data?.message || "Lỗi hệ thống khi gửi yêu cầu.");
        } finally {
            setWithdrawLoading(false);
        }
    };

    const handleConvertCustomerToAgency = async () => {
        if (!selectedCustomer) return;
        setConvertLoading(true);
        try {
            const res = await api.post('/agency/convert-client', { customerId: selectedCustomer._id });
            if (res.data.success) {
                alert(res.data.message || `✅ Thăng cấp đại lý tuyến dưới thành công!`);
                setShowConvertModal(false);
                setSelectedCustomer(null);
                fetchAllData();
            }
        } catch (err) {
            alert(err.response?.data?.message || "Lỗi xử lý phân cấp hệ thống.");
        } finally {
            setConvertLoading(false);
        }
    };

   
    if (loading) return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-black">
            <Spinner animation="grow" variant="warning" />
        </div>
    );

    const currentLevel = agencyData?.agencyLevel || 1;
    
    return (
        <Container fluid className="py-4 px-lg-5 agency-luxury-bg min-vh-100">
            {/* BANNER ĐẠI LÝ HOÀN THIỆN */}
            <div className="agency-banner mb-5 p-4 rounded-4 shadow-gold-lg">
                <Row className="align-items-center">
                    <Col md={7}>
                        <Badge bg="warning" text="dark" className="mb-2 px-3 py-2 fw-black text-uppercase">
                            <FaGem className="me-2"/> ĐỐI TÁC CHIẾN LƯỢC • CẤP {currentLevel}
                        </Badge>
                        <h1 className="text-white fw-black display-5 mb-1">
                            {agencyData?.displayName || agencyData?.agencyName || 'ĐẠI LÝ NE X BOT'}
                        </h1>
                        <p className="text-secondary italic mb-3">Hệ thống quản trị doanh thu & Quỹ thưởng đa cấp</p>
                        
                        {/* HIỂN THỊ LINK GỌN GÀNG */}
                        <div className="bg-black bg-opacity-40 p-2 rounded-3 border border-warning border-opacity-25 d-inline-flex align-items-center">
                            <span className="text-warning small px-2 fw-bold">LINK:</span>
                            <code className="text-white small px-2" style={{maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {landingLink}
                            </code>
                            <Button size="sm" variant="warning" className="ms-2 px-3 fw-bold" onClick={copyLink}>
                                <FaCopy />
                            </Button>
                        </div>
                    </Col>
                    
                    <Col md={5} className="text-md-end mt-4 mt-md-0">
                        <div className="d-grid gap-2">
                            <Button variant="outline-warning" className="fw-bold px-4 rounded-pill" onClick={fetchAllData}>
                                <FaSync className="me-2"/> LÀM MỚI DỮ LIỆU
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
            <Row className="g-4 mb-5">
                <Col lg={4}>
                    <Card className="metric-card shadow-sm border-0 h-100">
                        <Card.Body className="p-4 text-start">
                            <div className="d-flex justify-content-between">
                                <div className="icon-box-gold"><FaWallet /></div>
                                <div className="text-end">
                                    <small className="text-secondary uppercase fw-bold">Số dư khả dụng</small>
                                    <h2 className="text-white fw-black mt-1">{(summary?.balance || 0).toLocaleString()}đ</h2>
                                </div>
                            </div>
                            <Button variant="warning" className="w-100 mt-4 fw-black rounded-3" onClick={() => setShowWithdrawModal(true)} disabled={summary?.balance < 50000}>YÊU CẦU RÚT TIỀN</Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={4}>
                    <Card className="metric-card shadow-sm border-0 h-100">
                        <Card.Body className="p-4 text-start">
                            <div className="d-flex justify-content-between">
                                <div className="icon-box-blue"><FaUsers /></div>
                                <div className="text-end">
                                    <small className="text-secondary uppercase fw-bold">Tổng mạng lưới quản lý</small>
                                    <h2 className="text-white fw-black mt-1">{summary?.totalCustomers || 0} User</h2>
                                </div>
                            </div>
                            <div className="mt-4">
                                <div className="d-flex justify-content-between mb-1">
                                    <small className="text-slate-400">Đang chạy Bot: {summary?.activeCustomers}</small>
                                    <small className="text-info">{((summary?.activeCustomers || 0) / (summary?.totalCustomers || 1) * 100).toFixed(0)}%</small>
                                </div>
                                <ProgressBar variant="info" now={(summary?.activeCustomers || 0) / (summary?.totalCustomers || 1) * 100} className="bg-dark" style={{height: '6px'}} />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={4}>
                    <Card className="metric-card shadow-sm border-0 h-100">
                        <Card.Body className="p-4 text-start">
                            <div className="d-flex align-items-center mb-3">
                                <div className="icon-box-green"><FaLink /></div>
                                <h6 className="ms-3 text-white mb-0 uppercase fw-bold">Link Tuyển Tuyến Dưới</h6>
                            </div>
                            <div className="bg-black p-3 rounded-3 border border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
                                <code className="text-warning text-truncate me-2" style={{fontSize: '0.8rem'}}>{landingLink}</code>
                                <Button size="sm" variant={copied ? "success" : "outline-warning"} onClick={() => copyLink(agencyData?.agencySlug)}>
                                    {copied ? <FaCheckCircle /> : <FaCopy />}
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Card className="bg-dark border-0 shadow-lg rounded-4 overflow-hidden">
                <Tabs defaultActiveKey="direct-clients" id="history-tabs" className="custom-luxury-tabs p-3">
                    <Tab eventKey="direct-clients" title={<span><FaUserCheck className="me-2"/> Khách trực tiếp</span>}>
                        <div className="table-responsive">
                            <Table hover className="align-middle mb-0 custom-luxury-table text-center">
                                <thead>
                                    <tr>
                                        <th className="ps-4 text-start">EMAIL KHÁCH HÀNG</th>
                                        <th>SỐ TÀI KHOẢN MT5</th>
                                        <th>SỐ DƯ TÀI KHOẢN</th>
                                        <th>LỢI NHUẬN RÒNG</th>
                                        <th>PHÍ HỢP TÁC 20%</th>
                                        <th>HOA HỒNG TRỰC TIẾP (60%)</th>
                                        <th>THAO TÁC</th>
                                    </tr>
                                </thead>
                               <tbody>
// Thay đoạn map trong Tab "Khách trực tiếp" bằng đoạn này:
{directCustomers.map((item, idx) => {
    // 1. Phân tách dữ liệu an toàn
    const stats = item.hubStats || {};
    const accountId = item.accountId || "N/A";
    const balance = Number(stats.current_balance || 0);
    const profit = Number(stats.current_profit || 0);
    const rawFee = Number(stats.feeVND || 0);
    
    // 2. Tính toán phí
    const fee20Percent = Math.round(rawFee * 0.20);
    const agencyShare = Math.round(rawFee * 0.60);

    return (
        <tr key={idx}>
            <td className="ps-4 text-start fw-bold text-white">{item.email}</td>
            <td className="text-info font-mono fw-bold">{accountId}</td>
            <td className="text-light">${balance.toLocaleString()}</td>
            <td className={profit >= 0 ? "text-success fw-bold" : "text-danger fw-bold"}>
                ${profit.toLocaleString()}
            </td>
            <td className="text-white fw-bold">{fee20Percent.toLocaleString()}đ</td>
            <td className="text-warning fw-black">{agencyShare.toLocaleString()}đ</td>
            <td>
                <Button size="sm" variant="outline-warning" className="rounded-pill" onClick={() => { setSelectedCustomer(item); setShowConvertModal(true); }}>
                    NÂNG CẤP
                </Button>
            </td>
        </tr>
    );
})}
</tbody>
                            </Table>
                        </div>
                    </Tab>
                    <Tab eventKey="sub-agencies" title={<span><FaSitemap className="me-2"/> Đại lý dưới quyền</span>}>
                        <Table hover className="custom-luxury-table text-center align-middle">
                            <thead><tr><th>TÊN ĐẠI LÝ</th><th>SLUG</th><th>CẤP</th><th>KHÁCH F1</th><th>DOANH THU</th></tr></thead>
                            <tbody>
                                {subAgencies.map((a, i) => (
                                    <tr key={i}><td>{a.agencyName}</td><td>{a.agencySlug}</td><td>{a.agencyLevel}</td><td>{a.totalDirectClients}</td><td>{a.totalRevenueGenerated}</td></tr>
                                ))}
                            </tbody>
                        </Table>
                    </Tab>
                    <Tab eventKey="sub-clients" title={<span><FaUsers className="me-2"/> Khách hàng / Đại lý gián tiếp</span>}>
    <div className="table-responsive">
        <Table hover className="align-middle mb-0 custom-luxury-table text-center">
            <thead>
                <tr>
                    <th className="ps-4 text-start">EMAIL THÀNH VIÊN</th>
                    <th>ĐẠI LÝ QUẢN LÝ TRỰC TIẾP</th>
                    <th>TÀI KHOẢN MT5</th>
                    <th>SỐ DƯ HIỆN TẠI</th>
                    <th>LỢI NHUẬN KHÁCH ĐẠT ĐƯỢC</th>
                    {/* Bổ sung cột phí hợp tác */}
                    <th>PHÍ HỢP TÁC 20%</th>
                    <th>DÒNG HOA HỒNG (15%)</th>
                </tr>
            </thead>
            <tbody>
                {subCustomers.filter(Boolean).length > 0 ? (
                    subCustomers.filter(Boolean).map((item, idx) => {
                        const stats = item.hubStats || {};
                        const rawFee = Math.max(0, stats.feeVND || 0);
                        // Tính toán phí 20%
                        const fee20Percent = Math.round(rawFee * 0.20);
                        // Tính toán dòng hoa hồng 15% (giữ nguyên logic cũ của bố)
                        const displayAmount = currentLevel === 1 ? "Dồn Quỹ Thưởng Nhánh" : `${Math.round(rawFee * 0.15).toLocaleString()}₫`;
                        
                        return (
                            <tr key={idx}>
                                <td className="ps-4 text-start text-white fw-bold">{item.email}</td>
                                <td className="text-info fw-bold font-mono">{item.parentAgencySlug}</td>
                                <td className="text-warning font-mono">{item.accountId || 'N/A'}</td>
                                <td className="text-slate-400">${(stats.current_balance || 0).toLocaleString()}</td>
                                <td className={(stats.current_profit || 0) >= 0 ? "text-success fw-bold" : "text-danger fw-bold"}>
                                    ${(stats.current_profit || 0).toLocaleString()}
                                </td>
                                {/* Hiển thị phí 20% */}
                                <td className="text-white fw-bold">{fee20Percent.toLocaleString()}đ</td>
                                <td className="text-warning fw-black">{displayAmount}</td>
                            </tr>
                        );
                    })
                ) : (
                    <tr><td colSpan="7" className="text-center py-5 text-muted">Chưa phát hiện thành viên hoặc đại lý gián tiếp ở các tầng sau.</td></tr>
                )}
            </tbody>
        </Table>
    </div>
</Tab>
                    <Tab eventKey="settings" title="Cấu hình ví">
                        <div className="p-4" style={{ maxWidth: '600px' }}>
                            <Form>
                                <Form.Group className="mb-3"><label className="lux-label">NGÂN HÀNG</label><Form.Control className="lux-input" value={bankForm.bankName} onChange={e => setBankForm({...bankForm, bankName: e.target.value})} /></Form.Group>
                                <Button variant="warning" onClick={handleUpdateBank}>LƯU VÍ</Button>
                            </Form>
                        </div>
                    </Tab>
                </Tabs>
            </Card>
            <style>{`.agency-luxury-bg { background-color: #020617; } .agency-banner { background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); border-left: 8px solid #eab308; } .metric-card { background: #111827; } .custom-luxury-tabs .nav-link.active { background: #111827 !important; color: #eab308 !important; border-bottom: 3px solid #eab308 !important; } .custom-luxury-table { background: #111827; } .custom-luxury-table thead th { background: #1e293b; color: #94a3b8; }`}</style>
        </Container>
    );
};

export default AgencyDashboard;